export const QUERY_KEY_DOCUMENT_HISTORY = 'document-history';
export const DOCUMENT_HISTORY_ACTIONS = [
  'update-data',
  'create-data',
  'delete-data',
];
// MVP: single page, no cursor-following — 100 covers realistic annotation timelines.
export const DOCUMENT_HISTORY_PAGE_SIZE = 100;
export const MAX_VISIBLE_CHANGES = 5;
// Consecutive same-source entries further apart than this start a new group —
// distinct user actions shouldn't collapse under one (newest) header timestamp.
export const MAX_GROUP_GAP_MS = 5 * 60 * 1000;

// Icon treatment from the Helene design system (node 11781:98): 20×20, stroke 1.5.
export const DOCUMENT_HISTORY_ICON_SIZE = 20;
export const DOCUMENT_HISTORY_ICON_STROKE = 1.5;

export const ROW_MIN_HEIGHT = 24;
export const NESTED_ROW_INDENT = 3.5;
export const ROW_SPACING = 1.5;

export const FEATURE_ICON_SIZE = 32;
export const FEATURE_ICON_GAP = 1;
